<template>
  <el-dialog
    class="radish-dia"
    title="收到Offer"
    top="70px"
    :modal="false"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form ref="form" :model="form" label-width="120px">
      <el-form-item label="候选人"> <el-input v-model="form['候选人']" disabled></el-input> </el-form-item>
      <el-form-item label="顾问"> <el-input v-model="form['顾问']" disabled></el-input> </el-form-item>
      <el-form-item label="职位"> <el-input v-model="form['职位']"></el-input> </el-form-item>
      <el-form-item label="专业职级"> <el-input v-model="form['专业职级']"></el-input> </el-form-item>
      <el-form-item label="固定年薪"> <el-input v-model="form['固定年薪']"></el-input> </el-form-item>
      <el-form-item label="offer签订日期">
        <el-date-picker v-model="form['offer签订日期']" type="date" placeholder="选择日期"> </el-date-picker>
      </el-form-item>
      <el-form-item label="预计到岗时间">
        <el-date-picker v-model="form['预计到岗时间']" type="date" placeholder="选择日期"> </el-date-picker>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
const dateFormat = require('dateformat')

export default {
  props: {
    onConfirm: Function,
  },
  data: function() {
    return {
      dialogVisible: false,
      form: {},
    }
  },
  methods: {
    show: function(row, pid) {
      const form = {}
      form['顾问'] = app.user.account
      form['候选人'] = row['姓名']
      form.rid = row.rid
      form.pid = pid
      this.form = form
      this.dialogVisible = true
    },
    handleConfirm: async function() {
      const dt = JSON.parse(JSON.stringify(this.form))
      dt['offer签订日期'] = dateFormat(dt['offer签订日期'], 'yyyy-mm-dd')
      dt['预计到岗时间'] = dateFormat(dt['预计到岗时间'], 'yyyy-mm-dd')
      const res = await app.service('radish').addOffer(dt)
      if (res.status == 'success' && this.onConfirm) {
        this.onConfirm()
      }
      this.$alert(res.msg)
      this.dialogVisible = false
    },
  },
}
</script>
